"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardCardType = exports.DashboardDateFilterStart = void 0;
var DashboardDateFilterStart;
(function (DashboardDateFilterStart) {
    DashboardDateFilterStart["SevenDays"] = "7 day";
    DashboardDateFilterStart["ThirtyDays"] = "30 day";
    DashboardDateFilterStart["ThreeMonths"] = "3 month";
    DashboardDateFilterStart["SixMonths"] = "6 month";
    DashboardDateFilterStart["TwelveMonths"] = "12 month";
})(DashboardDateFilterStart = exports.DashboardDateFilterStart || (exports.DashboardDateFilterStart = {}));
var DashboardCardType;
(function (DashboardCardType) {
    DashboardCardType["ActiveUsers"] = "active_users";
    DashboardCardType["LiveCampaigns"] = "live_campaigns";
    DashboardCardType["Visitors"] = "visitors";
    DashboardCardType["TagPerformance"] = "tag_performance";
    DashboardCardType["CampaignsLaunched"] = "campaigns_launched";
    DashboardCardType["CampaignsActivity"] = "campaigns_activity";
    DashboardCardType["AdsFlagship"] = "ads_flagship";
    DashboardCardType["AdsRecoAndMerch"] = "ads_reco_and_merch";
    DashboardCardType["CampaignStatus"] = "campaign_status";
    DashboardCardType["FlagUsage"] = "flag_usage";
    DashboardCardType["Alerts"] = "alerts";
    DashboardCardType["Integration"] = "integration";
    DashboardCardType["EmotionsAIInsights"] = "emotions_ai_insights";
})(DashboardCardType = exports.DashboardCardType || (exports.DashboardCardType = {}));
//# sourceMappingURL=types.js.map